// Central registry of all SVG assets that have been moved into Vite's
// pipeline. Using import.meta.glob ensures SVGO compression, content-hashed
// URLs, and automatic Workbox precaching.

import { SealType } from "system";

const _driverCardFront = import.meta.glob<string>(
  "/src/assets/driver-card/front/*.svg",
  { query: "?url", import: "default", eager: true },
);

export function driverCardFrontUrl(name: string): string {
  return _driverCardFront[`/src/assets/driver-card/front/${name}.svg`];
}

const _driverCardBack = import.meta.glob<string>(
  "/src/assets/driver-card/back/**/*.svg",
  { query: "?url", import: "default", eager: true },
);

export function driverCardBackUrl(prefix: string, idx: number): string | undefined {
  const padded = String(idx).padStart(2, "0");
  return _driverCardBack[`/src/assets/driver-card/back/${prefix}/${padded}.svg`];
}

const _frameBorder = import.meta.glob<string>(
  "/src/assets/frame-border/*.svg",
  { query: "?url", import: "default", eager: true },
);

export function frameBorderUrl(name: string): string {
  return _frameBorder[`/src/assets/frame-border/${name}.svg`];
}

const _selectBg = import.meta.glob<string>(
  "/src/assets/select-bg/*.svg",
  { query: "?url", import: "default", eager: true },
);

export const selectBgSlim = [0, 1, 2, 3].map(
  (i) => _selectBg[`/src/assets/select-bg/slim-${i}.svg`],
);
export const selectBgThick = [0, 1, 2, 3].map(
  (i) => _selectBg[`/src/assets/select-bg/thick-${i}.svg`],
);

const _static = import.meta.glob<string>(
  [
    "/src/assets/logo.svg",
    "/src/assets/header-logo.svg",
    "/src/assets/kanji.svg",
    "/src/assets/tire-tread.svg",
    "/src/assets/ripple.svg",
    "/src/assets/splash.svg",
  ],
  { query: "?url", import: "default", eager: true },
);

export const logoUrl        = _static["/src/assets/logo.svg"];
export const headerLogoUrl  = _static["/src/assets/header-logo.svg"];
export const kanjiUrl       = _static["/src/assets/kanji.svg"];
export const rippleUrl      = _static["/src/assets/ripple.svg"];
export const splashUrl      = _static["/src/assets/splash.svg"];

const keppanLogoUrl = import.meta.glob<string>(
  "/src/assets/keppan/logo/*.svg",
  { query: "?url", import: "default", eager: true }
);

export function keppanLogo(type: SealType) {
  return keppanLogoUrl[`/src/assets/keppan/logo/${type}.svg`];
}